<template>
  <div class="date__actions_box">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="date__actions"
      :style="{
        backgroundColor: item.bg,
        color: item.color,
        bottom: (item.index + 1) * 30 + 'px',
        zIndex: item.isFrist ? 100 : 10,
        borderTop: borderTopBottom(item),
        borderBottom: borderTopBottom(item),
        borderLeft: borderLeft(item),
        borderRight: borderRight(item),
        left: item.isFrist ? '6px' : '',
        width:
          item.isFrist && item.isEnd && item.type
            ? `calc(100% - 12px)`
            : (item.isFrist || item.isEnd) && item.type
            ? `calc(100% - 6px)`
            : '100%',
      }"
    >
      <div
        v-if="item.isFrist"
        class="flex_start flex_center_align"
        :style="{
          color: item.color,
        }"
      >
        <svg-icon
          v-if="item.icon"
          :icon-class="item.icon"
          class="icon_data"
        ></svg-icon>
        <span class="title">{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Item',
    props: {
      start: {
        type: Boolean,
        default: false,
      },
      end: {
        type: Boolean,
        default: false,
      },
      itemType: {
        type: String,
        default: '',
      },
      dataList: {
        type: Array,
        default: () => {
          ;[]
        },
      },
    },
    data() {
      return {
        list: [],
      }
    },
    computed: {
      borderTopBottom() {
        return (item) => {
          if (item.type != 'hope' && item.type != 'dyhope') {
            return `2px dotted ${item.color}`
          } else {
            return ''
          }
        }
      },
      borderLeft() {
        return (item) => {
          if (item.isFrist && item.type != 'hope' && item.type != 'dyhope') {
            return `2px dotted ${item.color}`
          } else {
            return ''
          }
        }
      },
      borderRight() {
        return (item) => {
          if (item.isEnd && item.type != 'hope' && item.type != 'dyhope') {
            return `2px dotted ${item.color}`
          } else {
            return ''
          }
        }
      },
    },
    watch: {
      dataList: {
        immediate: true,
        handler: function (val) {
          this.list = val
        },
        deep: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .date__actions_box {
    position: absolute;
    width: 100%;
    bottom: 5px;
    left: 0;
  }
  .date__actions {
    font-size: 14px;
    color: #fff;
    white-space: nowrap;
    position: absolute;
    left: 0;
    height: 26px;
    display: flex;
    align-items: center;
    width: 100%;
    &.border {
      border: 2px dotted red;
    }

    .title {
      font-size: 12px;
      line-height: 26px;
      padding-left: 6px;
      display: block;
    }
    .icon_data {
      font-size: 26px;
      padding-left: 10px;
    }
  }
</style>
